import React from 'react';
import { DLSSize } from 'src/types/dls-size.enum';
import { ButtonSecondary } from '@americanexpress/dls-react';
import { IconTrash } from '@americanexpress/dls-icons';

export interface DeleteButtonProps {
    text?: string;
    showIcon?: boolean;
    'aria-label'?: string;
    'data-cy'?: string;
    className?: string;
    onClick: () => void | Promise<void>;
}

export default function DeleteButton({
    text,
    'aria-label': ariaLabel,
    'data-cy': dataCy,
    className,
    onClick
}: DeleteButtonProps): JSX.Element {
    return (
        <ButtonSecondary
            size={DLSSize.MEDIUM}
            icon={<IconTrash />}
            aria-label={ariaLabel}
            data-cy={dataCy}
            className={className}
            onClick={onClick}
        >
            {text}
        </ButtonSecondary>
    );
}
